import OauthError from 'app/services/oauth/OauthError';
import { ResponseError } from 'app/constants/ResponseErrors';

export const withOauthErrors = (wrapRequest) => (options = {}) => (dispatch, getState) =>
  wrapRequest(options)(dispatch, getState).catch((e) => {
    if (e instanceof ResponseError) {
      throw OauthError.tryParse(e.response, { cause: e }) || e;
    } else {
      throw e;
    }
  });
